import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

// Grouped bar chart used by both "Book Wise Distribution" and
// "Year Wise Growth" dashboard widgets.
export default function TspBarChart({ data, xKey, series, height = 220 }) {
  return (
    <div className="tsp-bar-chart" style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 10, right: 12, left: -12, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#EEF1F6" />
          <XAxis dataKey={xKey} tickLine={false} axisLine={false} fontSize={11} stroke="#9AA3B2" />
          <YAxis tickLine={false} axisLine={false} fontSize={11} stroke="#9AA3B2" />
          <Tooltip />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          {series.map((s) => (
            <Bar key={s.key} dataKey={s.key} name={s.name} fill={s.color} radius={[4, 4, 0, 0]} barSize={14} />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
